var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99983 16.63C7.71649 16.63 7.47899 16.5342 7.28733 16.3425C7.09566 16.1508 6.99983 15.9133 6.99983 15.63V9.63L1.08307 2.08C0.844242 1.78 0.809575 1.46334 0.979075 1.13C1.14841 0.796672 1.42199 0.630005 1.79983 0.630005H16.1998C16.5777 0.630005 16.8512 0.796672 17.0206 1.13C17.1901 1.46334 17.1554 1.78 16.9166 2.08L10.9998 9.63V15.63C10.9998 15.9133 10.904 16.1508 10.7123 16.3425C10.5207 16.5342 10.2832 16.63 9.99983 16.63H7.99983ZM8.99983 9.46325L14.6498 2.29675H3.34983L8.99983 9.46325Z",
    fill: "#0C70E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.cc0056431a13cfbe67a59bbb8e258e53.svg";
export { ForwardRef as ReactComponent };